(() => {
  const normalizeQuery = (value) => {
    const expanded = window.StoreSearchAliases?.expand(value) || value;
    return expanded
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .map((term) => {
        if (/[*:"()]/.test(term)) return term;
        return `${term}*`;
      })
      .join(' ');
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = new URL(form.action, window.location.origin);
    if (!action.pathname.endsWith('/search')) return;

    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input || !input.value.trim()) return;

    event.preventDefault();

    const destination = new URL(form.action, window.location.origin);
    const parameters = new URLSearchParams(new FormData(form));
    parameters.set('q', normalizeQuery(input.value));
    destination.search = parameters.toString();
    window.location.assign(destination.toString());
  });
})();
